"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _optionModule = _interopRequireDefault(require("./option.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isRealFormControl"],
  _excluded2 = ["isRealFormControl"],
  _excluded3 = ["id", "children", "className", "focusOnLabel", "name", "isButton", "isControlled", "label", "checked", "labelClassName", "additionalInfo", "onChange", "type", "inputClassName", "inputWrapperClassName", "ariaLabel", "ariaInvalid", "ariaDescribedBy", "describedById", "submitButton", "primaryLabelClassName", "isRealFormControl", "withContainer", "isBordered"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  /** Id for the input */
  id: _propTypes["default"].string,
  /** Required: name for the checkbox/radio input */
  name: _propTypes["default"].string.isRequired,
  /** Required: text (or markup) to show within the option's label */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  /** The value of the input */
  value: _propTypes["default"].string,
  /** Function to be called when a change event is fired by the input */
  onChange: _propTypes["default"].func,
  /** Checked/selected state of the input */
  checked: _propTypes["default"].bool,
  /** Custom class name to be added */
  className: _propTypes["default"].string,
  /** Custom class name to be added to label element */
  labelClassName: _propTypes["default"].string,
  /** Custom class name to be added to primary label element */
  primaryLabelClassName: _propTypes["default"].string,
  /** Expand focus state outline to wrap whole label */
  focusOnLabel: _propTypes["default"].bool,
  /** Add border, padding and spacing to the whole component */
  isButton: _propTypes["default"].bool,
  /** Uses a controlled component */
  isControlled: _propTypes["default"].bool,
  /** Optional additionalInfo */
  additionalInfo: _propTypes["default"].string,
  /** Optional class name to be added to input element */
  inputClassName: _propTypes["default"].string,
  /** Optional class name to be added to wrapper element */
  inputWrapperClassName: _propTypes["default"].string,
  /** The aria-label attribute to be added to input element */
  ariaLabel: _propTypes["default"].string,
  /** The aria-invalid attribute to be added to input element */
  ariaInvalid: _propTypes["default"].string,
  /** The aria-describedby attribute to be added to input element */
  ariaDescribedBy: _propTypes["default"].string,
  /** Id is related to aria-describedby attribute to be added to label element */
  describedById: _propTypes["default"].string,
  /** Whether to render an actual form control */
  isRealFormControl: _propTypes["default"].bool
};
var defaultProps = {
  id: undefined,
  value: undefined,
  checked: false,
  className: undefined,
  focusOnLabel: false,
  isButton: false,
  isControlled: false,
  labelClassName: undefined,
  primaryLabelClassName: undefined,
  onChange: function onChange() {},
  additionalInfo: undefined,
  name: undefined,
  inputClassName: undefined,
  inputWrapperClassName: undefined,
  ariaLabel: undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  describedById: undefined,
  isRealFormControl: true
};
var Input = function Input(_ref) {
  var isRealFormControl = _ref.isRealFormControl,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return isRealFormControl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({}, otherProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread({}, otherProps));
};
var Label = function Label(_ref2) {
  var isRealFormControl = _ref2.isRealFormControl,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return isRealFormControl ?
  /*#__PURE__*/
  /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
  (0, _jsxRuntime.jsx)("label", _objectSpread({}, otherProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread({}, otherProps));
};
var Option = function Option(props) {
  var id = props.id,
    children = props.children,
    className = props.className,
    focusOnLabel = props.focusOnLabel,
    name = props.name,
    isButton = props.isButton,
    isControlled = props.isControlled,
    label = props.label,
    checked = props.checked,
    labelClassName = props.labelClassName,
    additionalInfo = props.additionalInfo,
    onChange = props.onChange,
    type = props.type,
    inputClassName = props.inputClassName,
    inputWrapperClassName = props.inputWrapperClassName,
    ariaLabel = props.ariaLabel,
    ariaInvalid = props.ariaInvalid,
    ariaDescribedBy = props.ariaDescribedBy,
    describedById = props.describedById,
    submitButton = props.submitButton,
    primaryLabelClassName = props.primaryLabelClassName,
    isRealFormControl = props.isRealFormControl,
    withContainer = props.withContainer,
    isBordered = props.isBordered,
    allOtherProps = _objectWithoutProperties(props, _excluded3);
  var generatedId = "".concat(name, "_").concat((0, _react.useId)());
  var inputId = id || generatedId;
  var checkedStatus = isControlled || !isRealFormControl ? {
    checked: checked
  } : {
    defaultChecked: checked
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames4["default"])(_optionModule["default"]['c-option'], _optionModule["default"]["c-option--".concat(type)], _optionModule["default"]['joyfully-bold'], className, inputWrapperClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option--is-button'], isButton), _optionModule["default"]['c-option--focus-on-label'], focusOnLabel), _optionModule["default"]['c-option--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option--disabled'], allOtherProps.disabled)),
    "data-testid": "".concat(type, "-").concat(label && label.replace ? label.replace(/\s+/g, '-').toLowerCase() : ''),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Input, _objectSpread(_objectSpread(_objectSpread({
      type: type
    }, allOtherProps), {}, {
      onChange: onChange
    }, checkedStatus), {}, {
      id: inputId,
      name: name,
      className: (0, _classnames4["default"])(_optionModule["default"]['c-option__input'], _optionModule["default"]["c-option__input--".concat(type)], inputClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option__input--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option__input--disabled'], allOtherProps.disabled), _optionModule["default"]['c-option__label--with-container'], withContainer), _optionModule["default"]['c-option__label--is-bordered'], isBordered)),
      "aria-label": ariaLabel,
      "aria-invalid": ariaInvalid,
      "aria-describedby": ariaDescribedBy,
      isRealFormControl: isRealFormControl
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Label, {
      id: describedById,
      htmlFor: inputId,
      className: (0, _classnames4["default"])(_optionModule["default"]['c-option__label'], _optionModule["default"]["c-option__label--".concat(type)], labelClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _optionModule["default"]['c-option__label--with-container'], withContainer), _optionModule["default"]['c-option__label--is-bordered'], isBordered), _optionModule["default"]['c-option__label--with-secondary'], children), _optionModule["default"]['c-option__label--disabled'], allOtherProps.disabled), _optionModule["default"]['c-option__label--checked'], !isRealFormControl && checkedStatus.checked), _optionModule["default"]['c-option__label--focus-on-label'], focusOnLabel)),
      isRealFormControl: isRealFormControl,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames4["default"])(_optionModule["default"]['c-option__primary-label'], primaryLabelClassName),
        children: [label, additionalInfo && !withContainer && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames4["default"])(_optionModule["default"]['c-option__primary-label-aside']),
          children: additionalInfo
        })]
      }), additionalInfo && withContainer && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames4["default"])([_optionModule["default"]['c-option__primary-label--with-container']]),
        children: additionalInfo
      }), children && isButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _optionModule["default"]['c-option__secondary-label'],
        children: children
      })]
    })]
  });
};
Option.propTypes = propTypes;
Option.defaultProps = defaultProps;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Option);